import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import TesztlapokEditDto from 'app/admin/tesztlapok/dto/TesztlapokEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class TesztlapokEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'tesztlapLatticeEditControl';
	}

	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new TesztlapokEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new TesztlapokEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new TesztlapokEditService();
